import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  CardBody,
  Card,
  CardHeader
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import CustomDatePicker from "../../Components/Common/CustomDatePicker";
import { useSelector } from "react-redux";
import Benchmark from "./Benchmark";
import PerformanceTrend from "./PerformanceTrend";



const TeamBanchmark = () => {
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [leftFilter, setLeftFilter] = useState({
      label: "Yesterday",
      value: "Yesterday",
    });
  const [refresh, setRefresh] = useState(false);
  const handleRefresh = () => {
    setRefresh(!refresh);
  }
  const [currency, setCurrency] = useState('$');
 
  let date = new Date();
  date.setDate(date.getDate() - 1);

  const {
    currentOutlet
  } = useSelector((state) => ({
    currentOutlet: state.UserOutletGroup.currentOutlet
  }));

  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
  }, [currentOutlet]);

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Team Benchmark" pageTitle="Dashboard" activeDate={leftFilter} customDate={leftCustomDate} handleRefresh={handleRefresh} />
          <Card className="p-0 row card-body">
            <CardHeader className=" d-flex justify-content-between align-items-center border-0">
                  {/* Left Title & Subtitle with Icon */}
                  {/* <div className="d-flex align-items-start">
                    <div className={`icon-box rounded bg-danger text-white`}>
                        <i className="ri-line-chart-fill"></i>
                    </div>
                    <div className="ps-2">
                        <h4 className="card-title mb-1">Team Benchmark</h4>
                        <p className="text-muted mb-0">
                        Staff performance across courses - identify top performers and improvement opportunities
                        </p>
                    </div>
                  </div> */}
                  <div className="d-flex justify-content-end gap-2 align-items-center">
                    <CustomDatePicker
                      activeDate={leftFilter}
                      setActiveDate={setLeftFilter}
                      customDate={leftCustomDate}
                      setCustomDate={setLeftCustomDate}
                      posEnd={false}
                    />                        
                  </div>
              </CardHeader>
            {/* <CardBody className="mb-1"> */}
              
              
            {/* </CardBody> */}
          </Card>
          <Row>
              <Benchmark 
                activeDate={leftFilter}
                customDate={leftCustomDate} 
                currency={currency}
              />
              {/* <PerformanceTrend /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TeamBanchmark;
